var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user" }, [
    _c("p", { staticClass: "title" }, [_vm._v("1.客人信息")]),
    _c("div", { staticClass: "g-content" }, [
      _c("ul", [
        _c("li", [
          _c("div", { staticClass: "z-title" }, [_vm._v("来电电话")]),
          _c("div", { staticClass: "z-content" }, [
            _vm.userPhone && _vm.userArea
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "10px",
                      "border-right": "1px solid #ccc",
                      "padding-right": "10px"
                    }
                  },
                  [_vm._v("+" + _vm._s(_vm.userArea))]
                )
              : _vm._e(),
            _vm._v(_vm._s(_vm.userPhone))
          ])
        ]),
        _vm.isJYJForXL && ((_vm.vipPhone && _vm.isAmend) || !_vm.isAmend)
          ? _c("li", [
              _c("div", { staticClass: "z-title" }, [_vm._v("会员电话")]),
              !_vm.isAmend
                ? _c("div", { staticClass: "z-content" }, [
                    _c("div", { staticClass: "m-phone" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.vipPhone,
                            expression: "vipPhone"
                          }
                        ],
                        staticClass: "infoReceiverPhone text",
                        class: {
                          errorBorder:
                            !_vm.isPhone(_vm.vipPhone) ||
                            (_vm.isChecked && !_vm.vipPhone)
                        },
                        attrs: { type: "phone", placeholder: "手机号、固话" },
                        domProps: { value: _vm.vipPhone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.vipPhone = $event.target.value
                          }
                        }
                      }),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.vipPhone,
                            expression: "vipPhone"
                          }
                        ],
                        staticClass: "cross",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.vipPhone = ""
                          }
                        }
                      })
                    ]),
                    _c("span", { staticClass: "infoReceiverPhoneNum" }, [
                      _vm._v(_vm._s(_vm.vipPhone ? _vm.vipPhone.length : 0))
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "dark",
                        on: { click: _vm.copyMemberPhone }
                      },
                      [_vm._v("与来电电话一致")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isPhone(_vm.vipPhone),
                            expression: "!isPhone(vipPhone)"
                          }
                        ],
                        staticStyle: { color: "red", "margin-left": "5px" }
                      },
                      [
                        _vm._v(
                          "请输入正确的手机号码格式 8位/10位/11位/3位或4位区号-8位 数字"
                        )
                      ]
                    )
                  ])
                : _c("div", { staticClass: "z-content" }, [
                    _c("div", { staticClass: "m-phone" }, [
                      _vm._v(_vm._s(_vm.vipPhone))
                    ])
                  ])
            ])
          : _vm._e(),
        _c("li", [
          _c("div", { staticClass: "z-title" }, [_vm._v("收货人电话")]),
          _vm.userArea
            ? _c(
                "div",
                [
                  _c("cc-select", {
                    staticStyle: { top: "9px", "margin-right": "10px" },
                    attrs: {
                      width: 160,
                      labelKey: "name",
                      valueKey: "type",
                      headLabelKey: true,
                      options: _vm.phoneAreaCode
                    },
                    on: {
                      change: function($event) {
                        return _vm.$onFormChange()
                      }
                    },
                    model: {
                      value: _vm.countryCode,
                      callback: function($$v) {
                        _vm.countryCode = $$v
                      },
                      expression: "countryCode"
                    }
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.consigneePhone,
                        expression: "consigneePhone"
                      }
                    ],
                    staticClass: "infoReceiverPhone text",
                    class: {
                      errorBorder:
                        !_vm.isPhoneArea(_vm.consigneePhone, _vm.countryCode) ||
                        (_vm.isChecked && !_vm.consigneePhone)
                    },
                    attrs: {
                      type: "phone",
                      placeholder: "手机号",
                      maxlength: _vm.countryCode == "+86" ? 11 : 8
                    },
                    domProps: { value: _vm.consigneePhone },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.consigneePhone = $event.target.value
                      }
                    }
                  }),
                  _c("span", { staticClass: "infoReceiverPhoneNum" }, [
                    _vm._v(
                      _vm._s(_vm.consigneePhone ? _vm.consigneePhone.length : 0)
                    )
                  ]),
                  _c(
                    "a",
                    { staticClass: "dark", on: { click: _vm.copyPhone } },
                    [_vm._v("与来电电话一致")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isPhoneArea(
                            _vm.consigneePhone,
                            _vm.countryCode
                          ),
                          expression: "!isPhoneArea(consigneePhone,countryCode)"
                        }
                      ],
                      staticStyle: { color: "red", "margin-left": "5px" }
                    },
                    [_vm._v("手机号码格式与区号不匹配")]
                  )
                ],
                1
              )
            : _c("div", { staticClass: "z-content" }, [
                _c("div", { staticClass: "m-phone" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.consigneePhone,
                        expression: "consigneePhone"
                      }
                    ],
                    staticClass: "infoReceiverPhone text",
                    class: {
                      errorBorder:
                        !_vm.isPhone(_vm.consigneePhone) ||
                        (_vm.isChecked && !_vm.consigneePhone)
                    },
                    attrs: { type: "phone", placeholder: "手机号、固话" },
                    domProps: { value: _vm.consigneePhone },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.consigneePhone = $event.target.value
                      }
                    }
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.consigneePhone,
                        expression: "consigneePhone"
                      }
                    ],
                    staticClass: "cross",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.consigneePhone = ""
                      }
                    }
                  })
                ]),
                _c("span", { staticClass: "infoReceiverPhoneNum" }, [
                  _vm._v(
                    _vm._s(_vm.consigneePhone ? _vm.consigneePhone.length : 0)
                  )
                ]),
                _c("a", { staticClass: "dark", on: { click: _vm.copyPhone } }, [
                  _vm._v("与来电电话一致")
                ]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isPhone(_vm.consigneePhone),
                        expression: "!isPhone(consigneePhone)"
                      }
                    ],
                    staticStyle: { color: "red", "margin-left": "5px" }
                  },
                  [
                    _vm._v(
                      "请输入正确的手机号码格式 8位/10位/11位/3位或4位区号-8位 数字"
                    )
                  ]
                )
              ])
        ]),
        _c("li", [
          _c("div", { staticClass: "z-title" }, [_vm._v("收货人姓名")]),
          _c("div", { staticClass: "z-content" }, [
            _c("div", { staticClass: "m-phone infoReceiverName" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.consigneeName,
                    expression: "consigneeName"
                  }
                ],
                staticClass: "text",
                class: { errorBorder: _vm.isChecked && !_vm.consigneeName },
                attrs: { type: "text" },
                domProps: { value: _vm.consigneeName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.consigneeName = $event.target.value
                  }
                }
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.consigneeName,
                    expression: "consigneeName"
                  }
                ],
                staticClass: "cross",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.consigneeName = ""
                  }
                }
              })
            ]),
            _c("label", [
              _c("input", {
                attrs: { type: "radio", name: "receiverSex", value: "先生" },
                on: { change: _vm.saveConsigneeSex }
              }),
              _vm._v("\n            先生\n          ")
            ]),
            _c("label", [
              _c("input", {
                attrs: { type: "radio", name: "receiverSex", value: "女士" },
                on: { change: _vm.saveConsigneeSex }
              }),
              _vm._v("\n            女士\n          ")
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a426634", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a426634","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Pages/customer/User.vue
// module id = bks0
// module chunks = 1 2